// Turn an RTK Query error (or anything thrown by .unwrap()) into a readable
// Persian message that keeps the server's own text, so failed submits are
// never silent.
export function apiErrorMessage(err: any, fallback = "خطای ناشناخته"): string {
  if (!err) return fallback;
  const e = err.error && typeof err.error === "object" ? err.error : err;
  const status = e.status;
  const data = e.data;

  if (status === "FETCH_ERROR")
    return "اتصال به سرور برقرار نشد. اینترنت/فیلترشکن را بررسی کنید و دوباره تلاش کنید.";
  if (status === "TIMEOUT_ERROR") return "پاسخ سرور طول کشید. دوباره تلاش کنید.";
  if (status === "PARSING_ERROR") {
    if (e.originalStatus === 413)
      return "حجم فایل بیشتر از حد مجاز سرور است (413).";
    return `خطای سرور (${e.originalStatus ?? "?"})`;
  }

  let serverText = "";
  if (data && typeof data === "object") {
    const m = (data as any).message;
    if (Array.isArray(m)) serverText = m.join(" | ");
    else if (typeof m === "string") serverText = m;
    else if (typeof (data as any).error === "string") serverText = (data as any).error;
  } else if (typeof data === "string") {
    serverText = data.slice(0, 300);
  }

  const prefix: Record<number, string> = {
    400: "اطلاعات ارسالی پذیرفته نشد",
    401: "نشست شما منقضی شده است؛ دوباره وارد شوید",
    403: "دسترسی ندارید",
    404: "پیدا نشد",
    409: "تکراری است",
    413: "حجم فایل بیش از حد مجاز است",
    422: "فایل/داده نامعتبر است",
    500: "خطای داخلی سرور",
  };
  const head =
    typeof status === "number"
      ? `${prefix[status] ?? "خطا"} (${status})`
      : fallback;
  return serverText ? `${head}: ${serverText}` : head;
}
